import React, { useState, useEffect } from "react";
import "./BillwiseReport.css";

export default function PartywisePurchaseReport({fromDate,toDate}) {



  const [reportData, setReportData] = useState([]);
  const [totalQty, setTotalQty] = useState(0);
  const [totalAmount, setTotalAmount] = useState(0);
  const [totalPaid, setTotalPaid] = useState(0);
  const [totalBalance, setTotalBalance] = useState(0);

  useEffect(() => {
    if (fromDate && toDate) {
      fetchReport();
    }
  }, [fromDate, toDate]);

  const fetchReport = async () => {

    const res = await fetch(
      `http://103.79.74.237:8081/api/invoices/partywise-purchase?from=${fromDate}&to=${toDate}`
    );

    const data = await res.json();
    setReportData(data);

    let qty = 0;
    let amount = 0;
    let paid = 0;
    let balance = 0;

    data.forEach(row => {
      qty += Number(row.totalQty || 0);
      amount += Number(row.totalAmount || 0);
      paid += Number(row.paidAmount || 0);
      balance += Number(row.balanceAmount || 0);
    });

    setTotalQty(qty);
    setTotalAmount(amount);
    setTotalPaid(paid);
    setTotalBalance(balance);
  };

  const handlePrint = () => {

  const printWindow = window.open("", "_blank");

  printWindow.document.write(`
    <html>
    <head>
      <title>Partywise Purchase Report</title>
      <style>
        body {
          font-family: Arial, sans-serif;
          padding: 20px;
        }

        .report-wrapper {
          border: 2px solid #000;
          padding: 10px;
        }

      .header-section {
  position: relative;
  margin: -10px -10px 15px -10px;   /* extend to wrapper border */
  border-bottom: 2px solid #000;
  padding: 10px 10px 10px 10px;
}

        .company-section {
          text-align: center;
        }

        .title {
          font-size: 20px;
          font-weight: bold;
        }

        .sub-title {
          margin-top: 4px;
          font-size: 14px;
        }

        .date-section {
          position: absolute;
          right: 0;
          top: 0;
          text-align: right;
          font-weight: bold;
          font-size: 14px;
        }

        table {
          width: 100%;
          border-collapse: collapse;
        }

        th, td {
          border: 1px solid #000;
          padding: 6px;
          font-size: 14px;
          text-align: center;
        }

        th {
          background: #eaeaea;
        }

        tfoot td {
          font-weight: bold;
        }

        /* Column width balance */
        .col-inv { width: 10%; }
        .col-date { width: 15%; }
        .col-party { width: 25%; }
        .col-equal { width: 12%; }

      </style>
    </head>

    <body>

      <div class="report-wrapper">

        <div class="header-section">

          <div class="company-section">
            <div class="title">ORANGE TRADINGS</div>
            <div class="sub-title">DHARAPURAM ROAD, TIRUPUR - 641 601</div>
          </div>

          <div class="date-section">
            <div>From Date : ${fromDate}</div>
            <div>To Date&nbsp;&nbsp;&nbsp;: ${toDate}</div>
          </div>

        </div>

        <table>
    <thead>
<tr>
<th>Inv No</th>
<th>Date</th>
<th>Party</th>
<th>Total Qty</th>
<th>Total Amount</th>
<th>Paid</th>
<th>Balance</th>
</tr>
</thead>

          <tbody>
            ${reportData.map(row => `
              <tr>
                <td>${row.invoiceNo}</td>
                <td>${row.invoiceDate}</td>
                <td>${row.partyName}</td>
                <td>${row.totalQty}</td>
                <td>${Number(row.totalAmount).toFixed(2)}</td>
                <td>${Number(row.paidAmount).toFixed(2)}</td>
                <td>${Number(row.balanceAmount).toFixed(2)}</td>
              </tr>
            `).join("")}
          </tbody>

          <tfoot>
            <tr>
              <td colspan="3">Total</td>
              <td>${totalQty}</td>
              <td>${totalAmount.toFixed(2)}</td>
              <td>${totalPaid.toFixed(2)}</td>
              <td>${totalBalance.toFixed(2)}</td>
            </tr>
          </tfoot>

        </table>

      </div>

    </body>
    </html>
  `);

  printWindow.document.close();

  printWindow.onload = function () {
    printWindow.focus();
    printWindow.print();
    printWindow.close();
  };
};


  return (
    <div className="billwise-container">

     

      <div className="billwise-table-section">

        <div className="billwise-table-wrapper">
          <table className="billwise-table">

            <thead>
              <tr>
              <th>Inv</th>
<th>Date</th>
<th>Party</th>
<th>Qty</th>
<th>Amt</th>
<th>Paid</th>
<th>Bal</th>
              </tr>
            </thead>

            <tbody>
              {reportData.length > 0 ? (
                reportData.map((row, index) => (
                  <tr key={index}>
                    <td>{row.invoiceNo}</td>
                    <td>{row.invoiceDate}</td>
                    <td>{row.partyName}</td>
                    <td>{row.totalQty}</td>
                    <td>{row.totalAmount}</td>
                    <td>{row.paidAmount}</td>
                    <td>{row.balanceAmount}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="7" className="no-data">
                    No data found
                  </td>
                </tr>
              )}
            </tbody>

          </table>
        </div>

       <div className="del-summary">

  <div className="del-summary-row">

    <div className="summary-field">
      <label>Total Qty</label>
      <input value={totalQty} readOnly />
    </div>

    <div className="summary-field">
      <label>Total Amount</label>
      <input value={totalAmount.toFixed(2)} readOnly />
    </div>

  </div>

  <div className="del-summary-bottom">

    <div className="summary-field">
      <label>Paid</label>
      <input value={totalPaid.toFixed(2)} readOnly />
    </div>

    <div className="summary-field total">
      <label>Balance</label>
      <input value={totalBalance.toFixed(2)} readOnly />
    </div>

  </div>

</div>

        <div className="billwise-buttons">
          <button onClick={handlePrint}>Print</button>
        </div>

      </div>
    </div>
  );
}
